import React from "react";
import { Helmet } from "react-helmet-async";
import { Copy, Monitor, Wand2, Sparkles } from "lucide-react";
import Logo from "@/components/Logo";

const surveyLink = "https://forms.gle/your-google-form-link"; // Replace with actual form link

const WeNeedYourHelp: React.FC = () => {
  // ...existing code from Landing.tsx...
};

export default WeNeedYourHelp; 